import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export class NgxTranslateCacheBusterLoader extends TranslateHttpLoader {
    constructor(
        private httpClient: HttpClient,
        prefix: string = './assets/i18n/',
        suffix: string = '.json',
    ) {
        super(httpClient, prefix, suffix);
    }

    getTranslation(lang: string) {
        const version = require('../../../../../../package.json').version;
        const url = `${this.prefix}${lang}${this.suffix}?v=${version}`;

        return this.httpClient.get(url);
    }
}
